import { SURVEY_COLORS } from "./theme-constants";

interface TrainingNeedsAnalysisStylesProps {
  isMobile: boolean;
}

export const getSharedStyles = (theme: any) => ({
  container: {
    padding: (props: TrainingNeedsAnalysisStylesProps) => (props.isMobile ? "16px" : "16px 24px"),
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
      height: "auto",
      overflowY: "visible" as const,
    },
  },
  primaryButton: {
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    height: "40px",
    padding: "0 16px",
    backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    border: "none",
    textTransform: "none" as const,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiButton-endIcon": {
      marginLeft: "4px",
      "& svg": {
        fontSize: "12px !important",
      },
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
    "&:disabled": {
      opacity: 0.5,
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    },
  },
  fieldsContainer: {
    marginBottom: "40px",
    marginTop: "50px",
  },
  headerDescription: {
    color: SURVEY_COLORS.TEXT_SECONDARY,
    fontSize: "12px",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "16px",
    textAlign: "left" as const,
    lineHeight: "20px",
    "& p": {
      fontSize: "12px",
    },
    "& ul": {
      listStyleType: "disc",
      listStylePosition: "inside",
      marginTop: "8px",
      paddingInlineStart: "0px",
      fontSize: "12px",
    },
    "& li": {
      fontSize: "12px",
    },
    "& li + li": {
      marginTop: "4px",
    },
  },
  cardTitle: {
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: 600,
    marginBottom: "25px !important",
  },
  questionItem: {
    marginBottom: "32px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "space-between" as const,
    marginTop: "24px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column" as const,
      alignItems: "stretch" as const,
    },
  },
  contentCard: {
    backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    borderRadius: "8px",
    padding: "24px",
    marginBottom: "16px",
    border: `1px solid ${SURVEY_COLORS.BORDER_DEFAULT}`,
    overflowY: "auto" as const,
    overflowX: "hidden" as const,
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
    },
  },
  outlineButton: {
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    height: "40px",
    padding: "0 16px",
    backgroundColor: "transparent",
    color: SURVEY_COLORS.TEXT_PRIMARY,
    border: `1px solid ${SURVEY_COLORS.BLACK}`,
    textTransform: "none" as const,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiButton-startIcon": {
      marginRight: "4px",
      "& svg": {
        fontSize: "12px !important",
      },
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_HOVER_BG,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
  },
});
